import * as echarts from 'echarts'
import {
    colorRgb,
    selfAdaptionPX
} from './commonFun.js'
import { NumberUtils } from 'great-jsutils'
import china from "../../../public/china.json";
export default {
    // 首页字体动画
    textChart(container) {
        echarts.dispose(document.getElementById(container))
        let myChart = echarts.init(document.getElementById(container));
        let option = {
            graphic: {
                elements: [
                    {
                        type: 'text',
                        left: 'center',
                        top: 'center',
                        style: {
                            text: '\t\t\t\t\t“农业+金融+科技” \n\n 助力发展福安茶叶数字经济',
                            fontSize: selfAdaptionPX(0.6),
                            fontWeight: 'bold',
                            lineDash: [0, 200],
                            lineDashOffset: 0,
                            fill: 'transparent',
                            stroke: '#fff',
                            lineWidth: 1,
                            
                            
                        },
                        keyframeAnimation: {
                            duration: 3000,
                            loop: false,
                            keyframes: [
                                {
                                    percent: 0.7,
                                    style: {
                                        fill: 'transparent',
                                        lineDashOffset: 200,
                                        lineDash: [200, 0]
                                    }
                                },
                                {
                                    // Stop for a while.
                                    percent: 0.8,
                                    style: {
                                        fill: '#fff'
                                    }
                                },
                                {
                                    percent: 1,
                                    style: {
                                        fill: '#fff'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        };
        myChart.setOption(option);
        window.addEventListener('resize', function () {
            myChart.resize()
        });
    },
    backgroundLine(container, paramsData) {
        const hexToRgba = (hex, opacity) => {
            let rgbaColor = "";
            let reg = /^#[\da-f]{6}$/i;
            if (reg.test(hex)) {
                rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
      "0x" + hex.slice(3, 5)
    )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
            }
            return rgbaColor;
        }
        // echarts.dispose(document.getElementById(container))
        let myChart = echarts.init(document.getElementById(container));
        let option = {
            color: paramsData.colors,
            legend: {
                show: true,
                type: 'scroll',
                left: 'center',
                width: selfAdaptionPX(3.5),
                top: 0,
                textStyle: {
                    color: '#333',
                    fontSize: selfAdaptionPX(0.14)
                },
                data: paramsData.legendData
            },
            grid: {
                top: '10%',
                left:'2%',
                right:'2%',
                bottom:'3%',
                containLabel: true
            },
            tooltip:{
                trigger: "axis",
                show: true,
                confine: true,
                // formatter: function(params) {
                //     // console.log(params)
                //     let html = '';
                //     params.forEach(v => {
                //         html += `<p style="color: #666;font-size: 14px;line-height: 24px">
                //         ${v.marker}<span style="margin-left:5px;">${v.seriesName}</span>：<span style="color:${v.color}">${v.value}</span>
                //         </p>`
                //     })
                    

                //     return html
                // },
                // extraCssText: 'background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;',
                // axisPointer: {
                //     type: 'shadow',
                //     shadowStyle: {
                //         color: '#ffffff',
                //         shadowColor: 'rgba(225,225,225,1)',
                //         shadowBlur: 5
                //     }
                // }
            },
            xAxis: [{
                type: "category",
                boundaryGap: true,
                axisLabel: {
                    
                    // formatter: '{value}'+paramsData.dates,
                    textStyle: {
                        color: "#333"
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: "#D9D9D9"
                    }
                },
                data: paramsData.xAxisData
            }],
            yAxis: [{
                type: "value",
                scale: true,
                name: '',
                axisLabel: {
                    textStyle: {
                        color: "#666"
                    }
                },
                nameTextStyle: {
                    color: "#666",
                    fontSize: selfAdaptionPX(0.14),
                    lineHeight: 40
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: "#E9E9E9"
                    }
                },
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                }
            }],
            series: []
        };
        for (let j = 0; j < paramsData.lineData.length; j++) {
            option.series.push({
                name: paramsData.legendData[j],
                type: "line",
                smooth: true,
                // showSymbol: false,
                symbolSize: 5,
                zlevel: 3,
                lineStyle: {
                    normal: {
                        color: paramsData.colorList[j][0],
                        shadowBlur: 3,
                        shadowColor: hexToRgba(paramsData.colorList[j][0], 0.2),
                        shadowOffsetY: 8
                    }
                },
                itemStyle: {
                    // color: "#000",
                    color: paramsData.colors[j],
                    // borderColor: "#646ace",
                    // borderWidth: 1

                },
                areaStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0,
                            0,
                            0,
                            1,
                            [{
                                    offset: 0,
                                    color: hexToRgba(paramsData.colorList[j][0], 0.5)
                                },
                                {
                                    offset: 1,
                                    color: hexToRgba(paramsData.colorList[j][1], 0.1)
                                }
                            ],
                        ),
                    }
                },
                data: paramsData.lineData[j]
            })
        }

        myChart.setOption(option,true);
        window.addEventListener('resize', function () {
            myChart.resize()
        });
        return myChart;
    }
}



